import { SncPrivacyNoticeService } from './../shared/custom/snc-privacy-notice/snc-privacy-notice.service';
import { Injectable } from '@angular/core';
import { Headers, RequestOptions } from '@angular/http';

import 'rxjs/add/operator/map';

import { JwtHelper } from 'angular2-jwt';

@Injectable()
export class AuthService {
    redirectUrl: string;

    constructor(private jwtHelper: JwtHelper, private sncAvisoPoliticaPrivacidade: SncPrivacyNoticeService) { }

    logout() {
        this.sncAvisoPoliticaPrivacidade.recoveryPrivacyNoticeLocalStorage();
        localStorage.clear();
        this.sncAvisoPoliticaPrivacidade.savePrivacyNoticeLocalStorage();
    }

    isAuthenticated(): boolean {

        const token = localStorage.getItem('dn-senac-seguranca') ? JSON.parse(localStorage.getItem('dn-senac-seguranca'))["seguranca"] : null;
        if (token) {
            return !this.jwtHelper.isTokenExpired(token);
        }

        return false;
    }

    obterAuthHeader(): RequestOptions {
        const access_token = JSON.parse(localStorage.getItem('dn-senac-seguranca'))["seguranca"];
        const headers = new Headers({ 'Authorization': `Bearer ${access_token}`, 'Content-Type': 'application/json' });

        return new RequestOptions({ headers: headers });
    }

    obterLogin(converterParaJson: boolean = true): any {
        return JSON.parse(localStorage.getItem('dn-senac-seguranca'))["seguranca"];
    }
}



// WEBPACK FOOTER //
// ./src/app/_services/auth.service.ts